import React from 'react';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Box,
  LinearProgress,
  Chip
} from '@mui/material';
import WifiIcon from '@mui/icons-material/Wifi';
import DescriptionIcon from '@mui/icons-material/Description';
import SpeedIcon from '@mui/icons-material/Speed';

function BottomBar({ crawling, stats }) {
  return (
    <AppBar 
      position="fixed" 
      sx={{ 
        top: 'auto', 
        bottom: 0,
        bgcolor: 'rgba(0, 0, 0, 0.8)',
        backdropFilter: 'blur(10px)',
        borderTop: '1px solid rgba(0, 150, 136, 0.2)',
      }}
      elevation={0}
    >
      {crawling && (
        <LinearProgress 
          sx={{ 
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            '& .MuiLinearProgress-bar': {
              bgcolor: '#009688'
            }
          }} 
        />
      )}
      <Toolbar variant="dense" sx={{ minHeight: 48 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 3, width: '100%' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <WifiIcon sx={{ fontSize: 18, color: '#009688' }} />
            <Typography variant="caption" color="text.secondary">
              {crawling ? 'Crawling...' : 'Ready'}
            </Typography>
          </Box>

          {stats && (
            <>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <DescriptionIcon sx={{ fontSize: 18, color: '#009688' }} />
                <Typography variant="caption" color="text.secondary">
                  {stats.documentsFound || 0} documents found
                </Typography>
              </Box>

              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <SpeedIcon sx={{ fontSize: 18, color: '#009688' }} />
                <Typography variant="caption" color="text.secondary">
                  {stats.pagesCrawled || 0} pages crawled
                </Typography>
              </Box>
            </>
          )}

          <Box sx={{ ml: 'auto' }}>
            <Chip 
              label={crawling ? 'Active' : 'Idle'} 
              size="small" 
              sx={{ 
                bgcolor: crawling ? 'rgba(0, 150, 136, 0.3)' : 'rgba(255, 255, 255, 0.1)',
                fontSize: '0.7rem',
                height: 24
              }} 
            />
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default BottomBar;
